import Icon from '../components/Icon.vue'

Icon.register({
  sort: {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M41 288H279C300.4 288 311.1 313.9 296 329L177 448C167.6 457.4 152.4 457.4 143.1 448L24 329C8.9 313.9 19.6 288 41 288zM296 183L177 64C167.6 54.6 152.4 54.6 143.1 64L24 183C8.9 198.1 19.6 224 41 224H279C300.4 224 311.1 198.1 296 183z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/sort.js
// module id = j8Ky
// module chunks = 144